import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lightbulb, Sparkles, Scale, FileText, ArrowRight, CheckCircle2, Clock } from "lucide-react";
import api from "@/lib/api";
import { PageHeader } from "@/pages/Dashboard";

const ICONS = { "idea-validation": Lightbulb, "name-generator": Sparkles, "legal-structure": Scale, "business-plan": FileText };

export default function Workflows() {
  const navigate = useNavigate();
  const [workflows, setWorkflows] = useState([]);
  const [sessions, setSessions] = useState({});

  useEffect(() => {
    api.get("/workflows").then(async ({ data }) => {
      setWorkflows(data.workflows);
      const st = {};
      await Promise.all(data.workflows.map(async (w) => {
        try { const r = await api.get(`/workflows/${w.id}/session`); st[w.id] = r.data.session; } catch (e) { /* ignore */ }
      }));
      setSessions(st);
    }).catch(() => {});
  }, []);

  return (
    <div className="fv-fade-up max-w-4xl" data-testid="workflows-page">
      <PageHeader eyebrow="Guided AI Experience" title="Guided Workflows"
        subtitle="Let the AI Business Coach walk you through each step, one question at a time — then generate a polished result you can edit, refine, and export." />
      <div className="grid sm:grid-cols-2 gap-4">
        {workflows.map((w) => {
          const Icon = ICONS[w.id] || Sparkles;
          const s = sessions[w.id];
          const answered = s ? Object.keys(s.answers || {}).filter((k) => !k.startsWith("_") && String(s.answers[k]).trim()).length : 0;
          const done = s?.status === "completed";
          const inProgress = answered > 0 && !done;
          return (
            <button key={w.id} onClick={() => navigate(`/workflows/${w.id}`)} data-testid={`workflow-card-${w.id}`}
              className="text-left rounded-2xl border border-white/8 bg-[#121214] p-6 hover:border-[#D4AF37]/40 transition-colors group">
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/20 flex items-center justify-center"><Icon className="w-6 h-6 text-[#D4AF37]" /></div>
                {done ? <span className="flex items-center gap-1 text-[11px] text-emerald-300"><CheckCircle2 className="w-3.5 h-3.5" /> Completed</span>
                  : inProgress ? <span className="flex items-center gap-1 text-[11px] text-amber-300" data-testid={`workflow-resume-${w.id}`}><Clock className="w-3.5 h-3.5" /> Resume ({answered}/{w.steps})</span> : null}
              </div>
              <h3 className="font-heading text-xl text-white mb-1">{w.name}</h3>
              <p className="text-sm text-[#A1A1AA] mb-4">{w.description}</p>
              <span className="inline-flex items-center gap-1.5 text-sm text-[#D4AF37] group-hover:gap-2.5 transition-all">
                {done ? "View result" : inProgress ? "Continue" : "Start"} <ArrowRight className="w-4 h-4" />
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
